import { useMemo, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { deepMerge } from 'grommet/utils';
import _ from 'lodash';
import { useToast } from 'granite-admin/core/components/Toast';
import { updateTransitions } from 'granite-admin/common/ducks/transitions';
import useDeepCompareMemo from 'granite-admin/utils/useDeepCompareMemo';
import { getFetching, setFetching } from 'granite-admin/utils/auth-singleton';
import transitionApi from 'granite-admin/common/gateways/transition-api';
function createId() {
  return Math.floor(Date.now() * Math.random());
}
function useAllowedTransitions(props) {
  const {
    entity,
    fromStatus,
    hideErrorToast,
    customErrorText
  } = props || {};
  let uuid = useMemo(() => {
    // componentWillMount events
    let uuid = createId();
    if (entity) setFetching({
      entity,
      uuid
    });
    return uuid;
  }, []);
  const {
    errorToast
  } = useToast();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const transitions = useSelector(({
    common
  }) => common.transitions.transitions);
  const getStatusTransitions = useCallback(async uuid => {
    try {
      setLoading(true);
      let {
        allowed_managements,
        results = []
      } = await transitionApi.getAllowedTransitions(entity);
      let updatedTransitions = {};
      let obj = [...results, {
        status_name: undefined,
        pk: undefined
      }].reduce((acc, status) => {
        return {
          ...acc,
          [status.status_name]: {
            pk: status.pk,
            allowedTransitions: allowed_managements?.filter(i => i.from_state_pk === null && status.pk === undefined || i.from_state_pk === status.pk)?.map(i => ({
              label: i.to_state,
              pk: i.to_state_pk
            })) ?? []
          }
        };
      }, {});
      updatedTransitions[entity] = {
        ...(obj ?? {})
      };
      dispatch(updateTransitions(updatedTransitions));
      setFetching(uuid, {
        remove: true
      });
    } catch (e) {
      console.log('error', e);
      if (hideErrorToast) errorToast(customErrorText ?? e?.errors?.title ?? 'Unable to get allowed transitions');
    } finally {
      setLoading(false);
    }
  }, [errorToast, dispatch, entity, hideErrorToast, customErrorText]);
  useEffect(() => {
    if (!entity) return;
    let fetching = getFetching();
    let sameEntityFetching = fetching.filter(i => i.entity === entity);
    if (transitions?.[entity] || sameEntityFetching.length !== 0 && sameEntityFetching[0].uuid !== uuid) {
      setFetching(uuid, {
        remove: true
      });
      setLoading(false);
      return;
    }
    getStatusTransitions(uuid);
  }, [transitions, getStatusTransitions, entity, uuid]);
  return useDeepCompareMemo(() => {
    let allowedTransitions, fromStatusPk, fromStatusLabel;
    if (typeof fromStatus === 'number') {
      let [key, value] = Object.entries(transitions?.[entity] ?? {}).find(([key, value]) => value.pk === fromStatus) ?? [];
      allowedTransitions = value?.allowedTransitions;
      fromStatusPk = fromStatus;
      fromStatusLabel = key;
    } else {
      allowedTransitions = transitions?.[entity]?.[fromStatus]?.allowedTransitions;
      fromStatusPk = transitions?.[entity]?.[fromStatus]?.pk;
      fromStatusLabel = fromStatus;
    }
    return {
      allowedTransitions: allowedTransitions ?? [],
      allTransitions: transitions?.[entity] ?? [],
      loading,
      fromStatusPk,
      fromStatusLabel,
      statusList: Object.entries(transitions?.[entity] ?? {}).map(([name, value]) => ({
        name,
        pk: value.pk
      }))
    };
  }, [transitions, loading, fromStatus, entity]);
}
export default useAllowedTransitions;